import clsx from 'clsx'
import React, { FC, memo } from 'react'
import { useEn, useJa, useLang } from '../common/i18n/useLang'
import classes from './header.module.css'

const _Header: FC = () => {
  const { language } = useLang()
  return (
    <header className={classes.gHeader}>
      <div className={classes.gHeader_inner}>
        <h1 className={classes.gHeader_inner_logo}>AAO</h1>

        <div className={classes.gHeader_inner_right}>
          <div className={classes.languageBox}>
            <button
              type="button"
              onClick={useEn}
              className={clsx(
                classes.languageBox_item,
                language === 'en' && classes.languageBox_item__active
              )}
            >
              English
            </button>
            <button
              type="button"
              onClick={useJa}
              className={clsx(
                classes.languageBox_item,
                language === 'ja' && classes.languageBox_item__active
              )}
            >
              日本語
            </button>
          </div>
        </div>
      </div>
    </header>
  )
}

export const Header = memo(_Header)
